import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import GoalsAdd from './../../elements/goals/widget/goals_add';
import GoalsSearch from './../../elements/goals/widget/goals_search';

class ProigualdadGoals extends Component {
	render() {
		return (
			<GoalsList {...this.props} />
		)
	}

	componentWillMount() {
		this.props.fetchModalities();
		this.props.goalsShow(this.props.goals.pages.current);
	}
}

export class GoalsList extends Component {
	render() {
		let { goals } = this.props;

		let gu = _.find(goals.permissions, (o) => {return o==='Update'});
		let gd = _.find(goals.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{goals.isFetching ? <Loading /> :
				<table className={`inm-table`}>
					<thead>
					<tr>
						<th>ID</th>
						<th>Tipo</th>
						<th>Nombre</th>
						{/*<th>Modalidad</th>*/}
						<th>Eje Temático</th>
						<th>Estado</th>
					</tr>
					</thead>
					<tbody>
					{_.map(goals.list, (row, k) => {
						return (
							<tr key={k}>
								<td style={{width:'80px'}}>
									<div className="actions">
										{gu ? <NavLink to={`/proigualdad/metas/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
										{gd ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
									</div>
									{row.id}
								</td>
								<td><strong>{(row.type === 'RI' ? 'Rumbo a la Igualdad' : (row.type === 'MT' ? 'Meta Tipo' : 'Meta IMEF'))}</strong></td>
								<td>{row.name}</td>
								{/*<td>{(row.modality && row.modality.name ? row.modality.name:'')}</td>*/}
								<td style={{width: 20+'%'}}>{row.axis.name}</td>
								<td>{row.agenciable ? row.agenciable.name:'---'}</td>
							</tr>
						);
					})}
					</tbody>
				</table>}
				{goals.pages.total>20 &&
				<InmPagination
					key="goals-pages"
					current={goals.pages.current}
					total={goals.pages.total}
					nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		const { goals } = this.props;
		this.props.goalsShow(value, goals.filters);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la meta "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.deleteGoal(id)
		});
	}
}

export default BaseLayout(ProigualdadGoals, {
	title:"Metas Proigualdad",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <GoalsSearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <GoalsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/goals/index.jsx